import { createSelector } from '@ngrx/store';
import { CatalogState } from './catalog.reducer';

export const selectCatalogState = (state: { catalog: CatalogState }) => state.catalog;

export const selectCatalogData = createSelector(selectCatalogState, (state) => state.data);
export const selectCatalogLoading = createSelector(selectCatalogState, (state) => state.isLoading);
export const selectCatalogError = createSelector(selectCatalogState, (state) => state.error);
export const selectLastLoadedCustomerId = createSelector(selectCatalogState, (state) => state.lastLoadedCustomerId);
export const selectLastLoadedCustomerName = createSelector(selectCatalogState, (state) => state.lastLoadedCustomerName);

export const selectCommonAttributes = createSelector(
  selectCatalogData,
  (catalog) => catalog?.data?.commonAttributes ?? []
);

export const selectModelsAttributes = createSelector(
  selectCatalogData,
  (catalog) => catalog?.data?.modelsAttributes ?? []
);

export const selectCatalogIsLoadedForCustomer = (customerId: string) => createSelector(
  selectCatalogData,
  selectLastLoadedCustomerId,
  (data, lastCustomerId) => !!data && lastCustomerId === customerId
);
